import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchStudies = async ({ page, category }) => {
  const categoryQuery = category !== "all" ? `&category=${category}` : "";

  return await api.get(`/study?page=${page}${categoryQuery}`);
};

export const useGetStudiesQuery = ({ page, category }) => {
  return useQuery({
    queryKey: ["get-studies", page, category],
    queryFn: () => fetchStudies({ page, category }),
    select: (data) => {
      return data.data;
    },
    keepPreviousData: true,
  });
};
